function Event(){
	var funcs = [];

	var res = function(){
		for (var i in funcs){
			funcs[i].apply(null, arguments);
		}
	};

	res.on = function(f){
		if (typeof f == 'function'){
			funcs.push(f);
		}
	};

	return res;
}

module.exports = Event;
